import {
    RequestService,
    RequestServiceResponse,
} from '@tcc-online/request-service';

const ENDPOINT = '/tickets';

const ContactService = {
    sendRequest,
};

type SendRequestPayload = {
    email: string;
    message: string;
};

async function sendRequest(
    payload: SendRequestPayload,
): Promise<RequestServiceResponse<{ message?: string }>> {
    const { email, message } = payload;
    return await RequestService.post<
        { email: string; message: string },
        { message?: string }
    >(ENDPOINT, { email, message }, { ignoreAuth: true });
}

export default ContactService;
